export interface SprintTimeOffUser {
  userId: number;
  userLogin: string;
  userDisplayName: string;
  /** ISO date strings `YYYY-MM-DD` */
  daysOff: string[];
}

export function SprintTimeOffUserFromJSON(
  json: Record<string, any>,
): SprintTimeOffUser {
  return {
    userId: json["userId"],
    userLogin: json["userLogin"],
    userDisplayName: json["userDisplayName"],
    daysOff: Array.isArray(json["daysOff"]) ? json["daysOff"] : [],
  };
}
